export default __webpack_public_path__ + "static/media/delivery.7c30c46c.png";